import request from '@/utils/request'

export const getCurrencyRecordPage = (params = {}) => {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value)
    }
  })

  const suffix = query.toString() ? `?${query.toString()}` : ''

  return request(`/currency-record/page${suffix}`, {
    method: 'GET'
  })
}
